import { FC, ReactNode } from 'react';
import cx from 'classnames/bind';

import styles from './Layout.module.scss';

const cn = cx.bind(styles);

interface LayoutProps {
  children: ReactNode;
  className: string;
}

const Layout: FC<LayoutProps> = ({ children, className }) => (
  <section className={cn('container', className)}>{children}</section>
);

export default Layout;
